// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__30dGc","label":"LabeledBox_label__2if84"};